import common from '@page/common/js/common';
import nowEnv from '@global/helpers/setEnv';
import $ from 'jquery';

function corpPage() {
  if (nowEnv.myEquipment()) {
    // 卷軸
    $('.corp-menu > h3').next('ul').wrap('<div class="nanoscroll"></div>');

    $('.nanoscroll > ul').wrap('<div class="nanoscroll__content"></div>');

    setTimeout(() => {
      $('.nanoscroll').nanoScroller({
        contentClass: 'nanoscroll__content',
        alwaysVisible: true,
      });
      // 開開關關
      $('.corp-menu > h3').on('click tough', () => {
        $('.corp-menu > h3').toggleClass('open');
        $('.nanoscroll').toggleClass('open');
      });
    });
    // 在HowToBuy單元拿掉ABOUT PAZZO連結，反之
    if (/HowToBuy/.test(window.location.pathname.split('/')[2])) {
      $('h3').has('a').remove();
    }
    if (/AboutPazzo/.test(window.location.pathname.split('/')[2])) {
      $('h3').has('a').next('h3').remove();
    }
  }
}

corpPage();
